export default __webpack_public_path__ + "static/media/V490MANF1.16f83291.pdf";